<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>Careers</h2>
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>Careers</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Title Area -->